import React, { useCallback, useEffect, useMemo, useState } from "react";
import { DispatchTransactionEvent } from "../events/events";
import {
  SUSPENDED, ShowError, DROPDOWN_LIST_NONE,
  JSON_KEY_MESSAGE_TYPE, EVENT_TOPIC_FOR_TRANSACTION_SERVER, JSON_KEY_DESCRIPTION,
  JSON_KEY_SUBMITTER, JSON_KEY_STATUS,
  ITEM_STATUS, ITEM_CREATE, ITEM_MODIFY, FIRM_TYPE_BROKER, FIRM_TYPE_NAME_BROKER, FIRM_TYPE_NAME_CLEARING,
  FIRM_TYPE_NAME_DATAVENDOR, FIRM_TYPE_EXCHANGE, FIRM_TYPE_NAME_SURVEILLANCE, FIRM_TYPE_NAME_EXCHANGE,
  FIRM_TYPE_SURVEILLANCE, FIRM_TYPE_CLEARING, FIRM_TYPE_DATAVENDOR, ConvertToFirmTypeId,
  JSON_KEY_PARTICIPANT_TYPE, EVENT_TYPE_CHANGE_FIRM_STATUS, StatusSimpleOptions,
  EVENT_TYPE_FIRM_MODIFY, EVENT_TYPE_FIRM_CREATE,
  JSON_KEY_FIRM,
  NO, YES,
  JSON_KEY_WITHDRAW_ALL_ORDERS,
  ConvertStatusFromNameToId,
  SUSPEND,
  ConvertStatus,
  STATUS_ACTIVE,
  STATUS_SUSPEND,
  ConfirmConfirmCancelAndSubmit,
  ITEM_CANCEL_ALL_ORDERS,
} from "../../common/common";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "../tabs/tabs.css";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { selectTSUserId } from "../../redux/globalsSlice";
import { MSGTYPE_FIRM_CHANGE_STATUS, MSGTYPE_FIRM_CREATE, MSGTYPE_FIRM_MODIFY, MSGTYPE_PARTICIPANT_CANCEL_ALL_ORDERS, } from "../../common/msg_types";
import { RenderDropdown, InputField } from "../../common/utilies";
import { yesNoOptions } from "../../common/convert_functions";

const FirmsAdminForm = ({ rowData, onClose, firmOptions }) => {
   const typeOptions = useMemo(() => ([
      { id: DROPDOWN_LIST_NONE, name: DROPDOWN_LIST_NONE },
      { id: FIRM_TYPE_BROKER, name: FIRM_TYPE_NAME_BROKER },
      { id: FIRM_TYPE_DATAVENDOR, name: FIRM_TYPE_NAME_DATAVENDOR },
      { id: FIRM_TYPE_CLEARING, name: FIRM_TYPE_NAME_CLEARING },
      { id: FIRM_TYPE_EXCHANGE, name: FIRM_TYPE_NAME_EXCHANGE },
      { id: FIRM_TYPE_SURVEILLANCE, name: FIRM_TYPE_NAME_SURVEILLANCE },
   ]), []);

   const userId = useSelector(selectTSUserId);
   const [selectedTabIndex, setSelectedTabIndex] = useState(0);

   // Form handling
   const {
      handleSubmit,
   } = useForm({});

   // tab1
   const [code, setCode] = useState(rowData?.code ?? '');
   const [status, setStatus] = useState(SUSPEND);
   const [cancelAllOrders, setCancelAllOrders] = useState(NO);
   const [cancelAllOrdersDisabled, setCancelAllOrdersDisabled] = useState(false);

   // tab 2 & 3
   const [type, setType] = useState(DROPDOWN_LIST_NONE);
   const [description, setDescription] = useState(rowData?.descr ?? '');

   const handleCancel = () => {
      if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
      }
      onClose(); // your modal close function
   };

   const onFirmDropDownChange = useCallback((e) => setCode(e.target.value), [setCode]);
   const onStatusDropDownChange = useCallback((e) => setStatus(e.target.value), [setStatus]);
   const onTypeDropDownChange = useCallback((e) => setType(e.target.value), [setType]);
   const onCancelAllOrdersDropDownChange = (e) => setCancelAllOrders(e.target.value);
   
   const onFirmModifyDropDownChange = (e) => {
      setCode(e.target.value);
      setDescription('');
      setType(DROPDOWN_LIST_NONE);
      setStatus(SUSPENDED);
   };

   // const ConfirmAndSubmit = async ({ title, text, item }) => {
   //    const confirmed = await confirmationDialog({ title, text });
   //    if (confirmed) handleStatusConfirmationSubmit(item);
   // };

   const handleStatusConfirmationSubmit = (submitItem) => {
      const base = {
         [JSON_KEY_SUBMITTER]: userId,
         [JSON_KEY_FIRM]: code,
      };

      switch (submitItem) {
         case ITEM_STATUS:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_CHANGE_FIRM_STATUS,
               {
                  ...base,
                  [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_FIRM_CHANGE_STATUS,
                  [JSON_KEY_STATUS]: status,
                  [JSON_KEY_WITHDRAW_ALL_ORDERS]: cancelAllOrders,
               }
            );
            break;

         case ITEM_CANCEL_ALL_ORDERS:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               MSGTYPE_PARTICIPANT_CANCEL_ALL_ORDERS, // ← matches your original code
               {
                  ...base,
                  [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_PARTICIPANT_CANCEL_ALL_ORDERS,
               }
            );
            break;

         case ITEM_CREATE:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_FIRM_CREATE,
               {
                  ...base,
                  [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_FIRM_CREATE,
                  [JSON_KEY_DESCRIPTION]: description,
                  [JSON_KEY_PARTICIPANT_TYPE]: Number(type),
                  [JSON_KEY_STATUS]: status,
               }
            );
            break;

         case ITEM_MODIFY:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_FIRM_MODIFY,
               {
                  ...base,
                  [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_FIRM_MODIFY,
                  [JSON_KEY_DESCRIPTION]: description,
                  [JSON_KEY_PARTICIPANT_TYPE]: Number(type),
                  [JSON_KEY_STATUS]: status,
               }
            );
            break;

         default:
            console.log("FirmsAdminForm unknown submit item");
      }
   };


   const ValidateFields = () => {
      if (!code) return "Code is missing";
      if (!description) return "Description is missing";
      if (!type) return "Type is missing";
      if (!status) return "Status is missing";
      return null;
   };

   const handleCancelAllOrdersSubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);
      if (cancelAllOrders === NO) return ShowError("Cancel All Orders must be YES");

      ConfirmConfirmCancelAndSubmit({
         title: "Firm Cancel All Orders",
         text: `Do you want to cancel all orders on the firm: ${code}`,
         item: ITEM_CANCEL_ALL_ORDERS,
         cancel_all: cancelAllOrders,
         onSubmit: handleStatusConfirmationSubmit,
      });

      onClose(); // your modal close function
   };
   
   const handleStatusSubmit = () => {
      ConfirmConfirmCancelAndSubmit({
         title: "Firm Status Change",
         text: `Setting firm ${code} to ${ConvertStatus(status)}`,
         item: ITEM_STATUS,
         cancel_all: cancelAllOrders,
         onSubmit: handleStatusConfirmationSubmit,
      });
      onClose(); // your modal close function
   };

   const handleCreateSubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);

      ConfirmConfirmCancelAndSubmit({
         title: "Create Firm",
         text: `Creating new firm: ${code}`,
         item: ITEM_CREATE,
         cancel_all: false,
         onSubmit: handleStatusConfirmationSubmit,
      });
      onClose(); // your modal close function
   };

   const handleModifySubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);

      ConfirmConfirmCancelAndSubmit({
         title: "Modify Firm",
         text: `Modifying firm: ${code}`,
         item: ITEM_MODIFY,
         cancel_all: cancelAllOrders,
         onSubmit: handleStatusConfirmationSubmit,
      });
      onClose(); // your modal close function
   };

   useEffect(() => {
      if (!rowData) return;
         setCode(rowData.code || '');
         setDescription(rowData.descr || '');
         setStatus(rowData?.status ? ConvertStatusFromNameToId(rowData.status) : SUSPEND);
         setType(ConvertToFirmTypeId(rowData.p_type));
   }, [rowData]);

   useEffect(() => {
      if (selectedTabIndex === 2) {
         setStatus(SUSPENDED);
      }
   }, [selectedTabIndex]);

   // Sync behavior when status changes
   useEffect(() => {
      // console.log("Status changed to:", status);

      if (status === STATUS_SUSPEND) {
         setCancelAllOrders(YES);
         setCancelAllOrdersDisabled(true);
      } else if (status === STATUS_ACTIVE) {
         setCancelAllOrders(NO);
         setCancelAllOrdersDisabled(false);
      } else {
         setCancelAllOrdersDisabled(false); // fallback for other statuses
      }
   }, [status]);

   return (
      <div className="admin-form">
         <div className="admin-tabs">
         <h2 className="center-heading">Firm Administration</h2>
         <Tabs selectedIndex={selectedTabIndex} onSelect={setSelectedTabIndex} forceRenderTabPanel={true} className="admin-tabs" >
            <TabList>
               <Tab>Change Status</Tab>
               <Tab>Modify Firm</Tab>
               <Tab>Create Firm</Tab>
               <Tab>Cancell All Orders</Tab>
            </TabList>

            {/* Tab 1: Change Status */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleStatusSubmit)}>
               <div className="top">
                  {RenderDropdown("Code", code, firmOptions, onFirmDropDownChange)}
               
               </div>
               <div className="top">
                  {RenderDropdown("Status", status, StatusSimpleOptions, onStatusDropDownChange)}
               </div>
               
               {/* <div className="top">
                  {RenderDropdown("Cancel All Orders", cancelAllOrders, yesNoOptions, onCancelAllOrdersDropDownChange, cancelAllOrdersDisabled)}
               </div> */}

               <div className="top">
                  {RenderDropdown(
                     "Cancel All Orders",
                     status === STATUS_ACTIVE ? NO : cancelAllOrders, // force NO if Active
                     yesNoOptions,
                     status === STATUS_ACTIVE ? () => {} : onCancelAllOrdersDropDownChange, // ignore changes if Active
                     true
                  )}
               </div>

               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>

            {/* Tab 2: Modify Firm */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleModifySubmit)}>
               <div className="top">
                  {RenderDropdown("Code", code, firmOptions, onFirmModifyDropDownChange)}
               </div>

               <div>
                  <InputField label="Description" value={description} onChange={setDescription} />
               </div>

               <div className="top">
                  {RenderDropdown("Type", type, typeOptions, onTypeDropDownChange)}
               </div>
               {/*}
               <div className="top">
                  {RenderDropdown("Status", status, StatusSimpleOptions, onStatusDropDownChange)}
               </div>
               */}
               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>            
            
            {/* Tab 3: Create Firm */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleCreateSubmit)}>
               <div>
                  <InputField label="Code" value={code} onChange={setCode} />
               </div>

               <div>
                  <InputField label="Description" value={description} onChange={setDescription} />
               </div>

               <div className="top">
                  {RenderDropdown("Type", type, typeOptions, onTypeDropDownChange)}
               </div>

               {/*
               <div className="top">
                  {RenderDropdown("Status", status, StatusSimpleOptions, onStatusDropDownChange, true)}
               </div>
               */}
               
               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>

            {/* Tab 4: Cancel All Orders */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleCancelAllOrdersSubmit)}>
               <div className="top">
                  {RenderDropdown("Code", code, firmOptions, onFirmDropDownChange)}
               </div>

               <div className="top">
                  {RenderDropdown("Cancel All Orders", cancelAllOrders, yesNoOptions, onCancelAllOrdersDropDownChange, cancelAllOrdersDisabled)}
               </div>

               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>
            
         </Tabs>
         </div>
      </div>
   );
};

export default FirmsAdminForm;
